const externalPageTypes = ['external_url', 'link']

export const isExternalLinkPageType = (type: unknown) => {
    if (typeof type !== 'string') {
        return false
    }

    return externalPageTypes.includes(type)
}

export const isExternalLinkPage = (page: any) => {
    if (!page) {
        return false
    }

    if (isExternalLinkPageType(page.type)) {
        return true
    }

    if (typeof page.route !== 'string') {
        return false
    }

    const route = page.route.trim().toLowerCase()

    return route.startsWith('https://') || route.startsWith('http://')
}
